"use client";

import { InferRequestType, InferResponseType } from "hono";
import { useMutation } from "@tanstack/react-query";
import { client } from "@/lib/hono";

const endpoint = client.api.ai["lomda-open-ended-feedback"].$post;

type ResponseType = InferResponseType<typeof endpoint, 200>;
type RequestType = InferRequestType<typeof endpoint>["json"];

/** Runtime AI feedback for the open-ended block (public, anonymous). */
export const useOpenEndedFeedback = () =>
    useMutation<ResponseType, Error, RequestType>({
        mutationFn: async (json) => {
            const response = await endpoint({ json });
            if (!response.ok) throw new Error("Failed to generate feedback");
            return response.json();
        },
    });
